import { cn } from "@/lib/utils";

// Content is always rendered visible (no JS gating) so it can never be hidden by a
// missed IntersectionObserver, anchor jump, or disabled JS. A subtle motion-safe
// fade-up plays on mount as a light enhancement.
export function Reveal({
  children,
  className,
  delay = 0,
  as: As = "div",
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: React.ElementType;
}) {
  return (
    <As
      style={delay ? { animationDelay: `${delay}ms` } : undefined}
      className={cn("motion-safe:animate-[fade-up_0.6s_both]", className)}
    >
      {children}
    </As>
  );
}
